export const DOCTOR_REPORT_LOREAL_MARK_INFO = {
    // Траффик
    trafficTotal: {
        title: 'Траффик салона',
        low: {
            value: '0',
            markText: 'Очень низкий траффик салона',
            recomendationText: '',
        },
        medium: {
            value: '500',
            markText: 'Траффик салона ниже эталонного',
            recomendationText: '',
        },
        high: {
            value: '550',
            markText: 'Хороший траффик салона',
            recomendationText: '',
        },
    },
    trafficParik: {
        title: 'Траффик парикмахерского зала',
        low: {
            value: '0',
            markText: 'Очень низкий траффик парикмахерского зала',
            recomendationText: '',
        },
        medium: {
            value: '300',
            markText: 'Траффик парикмахерского зала ниже эталонного',
            recomendationText: '',
        },
        high: {
            value: '300',
            markText: 'Хороший траффик парикмахерского зала',
            recomendationText: '',
        },
    },
    trafficManicure: {
        title: 'Траффик маникюрного зала',
        low: {
            value: '0',
            markText: 'Очень низкий траффик маникюрного зала',
            recomendationText: '',
        },
        medium: {
            value: '50',
            markText: 'Траффик маникюрного зала ниже эталонного',
            recomendationText: '',
        },
        high: {
            value: '150',
            markText: 'Хороший траффик маникюрного зала',
            recomendationText: '',
        },
    },
    trafficOther: {
        title: 'Траффик других залов',
        low: {
            value: '0',
            markText: 'Очень низкий траффик других залов',
            recomendationText: '',
        },
        medium: {
            value: '30',
            markText: 'Траффик других залов ниже эталонного',
            recomendationText: '',
        },
        high: {
            value: '100',
            markText: 'Хороший траффик других залов',
            recomendationText: '',
        },
    },
    
    // Количество услуг для парикмахерского зала
    haircutsCnt: {
        title: 'Количество стрижек',
        low: {
            value: '0',
            markText: 'Очень мало стрижек',
            recomendationText: '',
        },
        medium: {
            value: '30',
            markText: 'Количество стрижек ниже эталонного',
            recomendationText: '',
        },
        high: {
            value: '190',
            markText: 'Хорошее количество стрижек',
            recomendationText: '',
        },
    },
    coloringCnt: {
        title: 'Количество окрашиваний',
        low: {
            value: '0',
            markText: 'Очень мало окрашиваний',
            recomendationText: '',
        },
        medium: {
            value: '30',
            markText: 'Количество окрашиваний ниже эталонного',
            recomendationText: '',
        },
        high: {
            value: '160',
            markText: 'Хорошее количество окрашиваний',
            recomendationText: '',
        },
    },
    haircareCnt: {
        title: 'Количество уходовых услуг',
        low: {
            value: '0',
            markText: 'Очень мало уходовых услуг',
            recomendationText: '',
        },
        medium: {
            value: '30',
            markText: 'Количество уходовых услуг ниже эталонного',
            recomendationText: '',
        },
        high: {
            value: '36',
            markText: 'Хорошее количество уходовых услуг',
            recomendationText: '',
        },
    },
    
    // Средний чек
    avgCheckSumTotal: {
        title: 'Средний чек салона',
        low: {
            value: '0',
            markText: 'Очень низкий средний чек салона',
            recomendationText: '',
        },
        medium: {
            value: '1500',
            markText: 'Средний чек салона ниже эталонного',
            recomendationText: '',
        },
        high: {
            value: '2750',
            markText: 'Хороший средний чек салона',
            recomendationText: '',
        },
    },
    avgCheckSumParik: {
        title: 'Средний чек парикмахерского зала',
        low: {
            value: '0',
            markText: 'Очень низкий средний чек парикмахерского зала',
            recomendationText: '',
        },
        medium: {
            value: '2000',
            markText: 'Средний чек парикмахерского зала ниже эталонного',
            recomendationText: '',
        },
        high: {
            value: '2300',
            markText: 'Хороший средний чек парикмахерского зала',
            recomendationText: '',
        },
    },
    
    // Новые клиенты (извне)
    newCountByMonth: {
        title: 'Новых клиентов',
        low: {
            value: '0',
            markText: 'Очень мало новых клиентов',
            recomendationText: '',
        },
        medium: {
            value: '40',
            markText: 'Новых клиентов меньше, чем должно быть',
            recomendationText: '',
        },
        high: {
            value: '165',
            markText: 'Хорошее количество новых клиентов',
            recomendationText: '',
        },
    },
    newCountByMonthParikAbsolute: {
        title: 'Новых клиентов для парикмахерского зала',
        low: {
            value: '0',
            markText: 'Очень мало новых клиентов для парикмахерского зала',
            recomendationText: '',
        },
        medium: {
            value: '20',
            markText: 'Новых клиентов для парикмахерского зала меньше, чем должно быть',
            recomendationText: '',
        },
        high: {
            value: '90',
            markText: 'Хорошее количество новых клиентов для парикмахерского зала',
            recomendationText: '',
        },
    },
    newCountByMonthParikCross: {
        title: 'Новых клиентов для парикмахерского зала (пришли из другого зала)',
        low: {
            value: '0',
            markText: 'Очень мало новых клиентов для парикмахерского зала из других залов',
            recomendationText: '',
        },
        medium: {
            value: '10',
            markText: 'Новых клиентов для парикмахерского зала из других залов меньше, чем должно быть',
            recomendationText: '',
        },
        high: {
            value: '16',
            markText: 'Хорошее количество новых клиентов для парикмахерского зала из других залов',
            recomendationText: '',
        },
    },
    
    // Конверсия
    conversion2: {
        title: 'Конверсия с 1 до 2',
        low: {
            value: '0%',
            markText: 'Клиенты почти не возвращаются после первого посещения',
            recomendationText: '',
        },
        medium: {
            value: '30%',
            markText: 'Клиенты не слишком хорошо приходят повторно после первого посещения',
            recomendationText: '',
        },
        high: {
            value: '60%',
            markText: 'Клиенты хорошо приходят повторно после первого посещения',
            recomendationText: '',
        },
    },
    conversion3: {
        title: 'Конверсия с 2 до 3',
        low: {
            value: '0%',
            markText: 'Клиенты практически не становятся постоянными после второго посещения',
            recomendationText: '',
        },
        medium: {
            value: '30%',
            markText: 'Клиенты не слишком хорошо становятся постоянными после второго посещения',
            recomendationText: '',
        },
        high: {
            value: '50%',
            markText: 'Клиенты часто становятся постоянными после второго посещения',
            recomendationText: '',
        },
    },
    conversion2Parik: {
        title: 'Конверсия с 1 до 2 по парикмахерскому залу',
        low: {
            value: '0%',
            markText: 'Клиенты парикмахерского зала почти не возвращаются после первого посещения',
            recomendationText: '',
        },
        medium: {
            value: '30%',
            markText: 'Клиенты парикмахерского зала не слишком хорошо приходят повторно после первого посещения',
            recomendationText: '',
        },
        high: {
            value: '60%',
            markText: 'Клиенты парикмахерского зала хорошо приходят повторно после первого посещения',
            recomendationText: '',
        },
    },
    conversion3Parik: {
        title: 'Конверсия с 2 до 3 по парикмахерскому залу',
        low: {
            value: '0%',
            markText: 'Клиенты парикмахерского зала практически не становятся постоянными после второго посещения',
            recomendationText: '',
        },
        medium: {
            value: '30%',
            markText: 'Клиенты парикмахерского зала не слишком хорошо становятся постоянными после второго посещения',
            recomendationText: '',
        },
        high: {
            value: '50%',
            markText: 'Клиенты парикмахерского зала часто становятся постоянными после второго посещения',
            recomendationText: '',
        },
    },
    
    // Количество услуг на клиента
    itemsCount: {
        title: 'Кол-во услуг на клиента',
        low: {
            value: '0',
            markText: 'Каждый клиент потребляет одни и те же услуги',
            recomendationText: '',
        },
        medium: {
            value: '3',
            markText: 'Каждый клиент потребляет недостаточное количество услуг',
            recomendationText: '',
        },
        high: {
            value: '5',
            markText: 'Каждый клиент потребляет множество услуг',
            recomendationText: '',
        },
    },
    itemsCountParik: {
        title: 'Кол-во услуг на клиента парикмахерского зала',
        low: {
            value: '0',
            markText: 'Каждый клиент парикмахерского зала потребляет одни и те же услуги',
            recomendationText: '',
        },
        medium: {
            value: '2',
            markText: 'Каждый клиент парикмахерского зала потребляет недостаточное количество услуг',
            recomendationText: '',
        },
        high: {
            value: '3',
            markText: 'Каждый клиент парикмахерского зала потребляет множество услуг',
            recomendationText: '',
        },
    },
}

export const DOCTOR_REPORT_LOREAL_MARK_TOOLTIPS: Record<string, string> = {
    trafficTotal: 'Количество уникальных клиентов, которые посетили салон за период. Посещением считается любая купленная услуга или товар. Если один и тот же клиент посещал салон несколько раз за период, то считается как один, а не как несколько.',
    trafficParik: 'Количество уникальных клиентов, которые посетили салон за период и оказанная услуга была с тегом «парикмахерский зал». Если один и тот же клиент посещал салон несколько раз за период, то считается как один, а не как несколько. Если клиент был за период хотя бы на одной парикмахерской услуге, то он попадает сюда.',
    trafficManicure: 'Количество уникальных клиентов, которые посетили салон за период и оказанная услуга была с тегом «маникюрный зал». Если один и тот же клиент посещал салон несколько раз за период, то считается как один, а не как несколько. Если клиент был за период хотя бы на одной маникюрной услуге, то он попадает сюда.',
    trafficOther: 'Количество уникальных клиентов, которые посетили салон за период и оказанная услуга была без тегов «парикмахерский зал» или «маникюрный зал». Если один и тот же клиент посещал салон несколько раз за период, то считается как один, а не как несколько. Если клиент был за период хотя бы на одной услуге не относящейся к маникюрному или парикмахерскому залу, то он попадает сюда.',
    haircutsCnt: 'Количество оказанных за период услуг с тегом «стрижки». Считаются все посещения с услугами с тегом «стрижки» по каждому клиенту. Если одному клиенту за один день оказали две услуги с тегом «стрижки», то они считаются как две отдельные.',
    coloringCnt: 'Количество оказанных за период услуг с тегом «окрашивания». Считаются все посещения с услугами с тегом «окрашивания» по каждому клиенту. Если одному клиенту за один день оказали две услуги с тегом «окрашивания», то они считаются как две отдельные.',
    haircareCnt: 'Количество оказанных за период услуг с тегом «уходовые услуги». Считаются все посещения с услугами с тегом «уходовые услуги» по каждому клиенту. Если одному клиенту за один день оказали две услуги с тегом «уходовые услуги», то они считаются как две отдельные.',
    avgCheckSumTotal: 'Сумма выручки по всем товарам и услугам за период делится на количество визитов за период. Пример: (800 + 1200 + 500 + 700 + 100) / 2 = 1650.',
    avgCheckSumParik: 'Сумма выручки по всем услугам с тегом «Парикмахерский зал» за период делится на количество визитов с этим тегом за период. Товары и оплата абонементом не учитываются.',
    newCountByMonth: 'Количество новых клиентов за период.',
    newCountByMonthParikAbsolute: 'Количество новых клиентов за период, у которых первое посещение было на услугу с тегом «парикмахерский зал». Это срез показателя «Новых клиентов».',
    newCountByMonthParikCross: 'Количество клиентов за период, которые уже ранее были в других залах, но впервые посетили услугу с тегом «парикмахерский зал».',
    conversion2: 'Доля клиентов, которые совершили второй визит (в любой день после первого), среди тех, кто совершил первый визит в период от 3 до 9 месяцев назад.',
    conversion2Parik: 'Доля клиентов, которые совершили второй визит, среди тех, кто совершил первый визит в период от 3 до 9 месяцев назад. И первый, и второй визиты были на услуги с тегом «Парикмахерский зал».',
    conversion3: 'Доля клиентов, которые совершили третий визит, среди тех, кто совершил первый и второй визиты в период от 3 до 9 месяцев назад.',
    conversion3Parik: 'Доля клиентов, которые совершили третий визит, среди тех, кто совершил первый и второй визиты в период от 3 до 9 месяцев назад. Первый, второй и третий визиты были на услуги с тегом «Парикмахерский зал».',
    itemsCount: 'Количество уникальных услуг на клиента за период. Считается как: сумма уникальных услуг по каждому клиенту за период / сумма уникальных клиентов за период.',
    itemsCountParik: 'Количество уникальных услуг с тегом «Парикмахерский зал» на клиента за период. Считается как: сумма уникальных услуг с тегом «Парикмахерский зал» по каждому клиенту за период / сумма уникальных клиентов за период, которые посещали услуги с этим тегом.',
}
